import { ActivatedRouteSnapshot } from "@angular/router";

export function redirectHelper (redirectData: Pick<ActivatedRouteSnapshot, 'routeConfig' | 'url' | 'params' | 'queryParams' | 'fragment' | 'data' | 'outlet' | 'title'>, targetBase: string) : string {
    console.log(redirectData);
    console.log(`${targetBase}${redirectData.url.join("/").substring(redirectData.routeConfig.path.length)}`);

    var result = `${targetBase}${redirectData.url.join("/").substring(redirectData.routeConfig.path.length)}`

    if (redirectData.queryParams) {
        console.log(redirectData.queryParams);
        const paramString = Object.keys(redirectData.queryParams)
            .map(key => `${key}=${redirectData.queryParams[key]}`)
            .join('&');

        result += `?${paramString}`;
    }

    if (redirectData.fragment) {
        result += `#${redirectData.fragment}`;
    }

    return result;
};